import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Button,  Header, Icon, Loader, Select, Table } from 'semantic-ui-react';
import './style.css';
import { toast } from 'react-toastify';
import { useStore } from '../../app/stores/store';
import { formatKey } from '../../app/stores/NFAI_Restoration_Smartflow/types';

const NFAI_Cutliststatusreport = () => {
  const {
    NFAI_Restoration_SmartflowsStore
  } = useStore();
 const { titleFilter, dropdownDetails, cutlistStatusreport, cutlistStatusReportData} = NFAI_Restoration_SmartflowsStore;

  const [selectedTitle, setSelectedTitle] = useState<string>('');

  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    reel_No: '',
    employee_ID: '',
    status: '',
    cutlist_Status: '',
  });
  
  const handleChange = async (e: any, data: any) => {
    setSelectedTitle(data.value);
    await fetchCutlistData(data.value);
  };

  const fetchTitleCodes = async () => {
    await titleFilter();
  };

  const fetchCutlistData = async (titleCode: string) => {
    if (titleCode === '') {
      NFAI_Restoration_SmartflowsStore.cutlistStatusReportData = [];
      setFilters({
        reel_No: '',
        employee_ID: '',
        status: '',
        cutlist_Status: '',
      })
    }else {
      setSelectedTitle(titleCode);
      setLoading(true);
       const payload={
        projectName: titleCode
      }
      await cutlistStatusreport(payload);
      setLoading(false);
    }
  };

  const generateCsvContent = (): string => {
    const rows: string[] = [];
    const keys = Object.keys(cutlistStatusReportData[0]).map((key) => formatKey(key));
    rows.push(keys.join(','));

    tableData.forEach((item) => {
      const values = Object.values(item);
      rows.push(values.join(','));
    });

    return rows.join('\n');
  };

  const handleDownload = () => {
    if (tableData.length === 0){
      toast.error('No data available to download.');
      return;
     }
    const csvContent = generateCsvContent();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${selectedTitle}_CutlistStatus.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    fetchTitleCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (e: any, { name, value }: any) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  
  const getUniqueValues = (key: string) => {
    if (cutlistStatusReportData.length === 0) return [];
  
    return cutlistStatusReportData
      .map((item) => (item as any)[key])
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort((a, b) => a.toString().localeCompare(b.toString(), undefined, { numeric: true }))
      .map((e, index) => ({ key: index, text: e, value: e }));
  };
  

 const tableData = cutlistStatusReportData.filter((item) => (filters.reel_No==='' || item.reel_No === filters.reel_No)
      && ((filters.employee_ID === '' || item.employee_ID === filters.employee_ID)) && ((filters.cutlist_Status === '' || item.cutlist_Status === filters.cutlist_Status)) 
      && ((filters.status === '' || item.status === filters.status)))
  return (
    <>
      <div>
        <div className="title_wise_cutlistreport">
          <Header>Cutlist Status Report</Header>
          <div style={{display:'flex', justifyContent:'space-between',marginBottom:'15px'}}>
            <div className="tr-dropdown" style={{display:'flex', justifyContent:'space-around'}}>
              <div style={{marginRight:'20px'}}><label>Title Code:</label>
              <Select
                placeholder="Select Title code"
                selection
                search
                clearable
                options={dropdownDetails.titleList as any}
                value={selectedTitle}
                onChange={handleChange}
              /></div>
            <div style={{ marginBottom: '15px' }}>
                  <Select
                  placeholder="Select Reel No"
                  name="reel_No"
                  value={filters.reel_No}
                  onChange={handleFilterChange}
                  style={{ marginRight: '10px' }} 
                  clearable
                  options={getUniqueValues('reel_No')} />
                  <Select
                  placeholder="Select Employee ID"
                  name="employee_ID"
                  value={filters.employee_ID}
                  onChange={handleFilterChange}
                  style={{ marginRight: '10px' }} 
                  clearable
                  options={getUniqueValues('employee_ID')} />
                  <Select
                    placeholder="Select status"
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                    style={{ marginRight: '10px' }}
                    clearable
                    options={getUniqueValues('status')}
                  />
                 <Select
                  placeholder="Select Cutlist Status"
                  name="cutlist_Status"
                  value={filters.cutlist_Status}
                  onChange={handleFilterChange}
                  style={{ marginRight: '10px' }}
                  clearable
                  options={getUniqueValues('cutlist_Status')}
                />
            </div>
            </div>
            {selectedTitle.length === 0 ? null : (
              <div>
                {/* Additional Select Fields */}
                <Button onClick={handleDownload}>
                  <Icon className="download" />
                </Button>
              </div>
            )}
          </div>

          <div style={{ height: '900px', overflow: 'auto' }}>
          <Table>
  <Table.Header style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
    <Table.Row>
      <Table.HeaderCell>#</Table.HeaderCell>
      {cutlistStatusReportData.length > 0 &&
        Object.entries(cutlistStatusReportData[0]).map(([key]) => (
          <Table.HeaderCell key={key}>
            {key
              .replaceAll('_', ' ')
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')}
          </Table.HeaderCell>
        ))}
    </Table.Row>
  </Table.Header>
  <Table.Body>
    {selectedTitle.length === 0 ? (
      <Table.Row>
        <Table.Cell colSpan={11} textAlign="center">
          Please Select Title code..
        </Table.Cell>
      </Table.Row>
    ) : loading ? (
      <Table.Row>
        <Table.Cell colSpan={11} textAlign="center">
          <Loader active inline="centered" size="large" />
          Please wait, this will take a few minutes...
        </Table.Cell>
      </Table.Row>
    ) : cutlistStatusReportData.length === 0 ? (
      <Table.Row>
        <Table.Cell colSpan={11} textAlign="center">
          No data available.
        </Table.Cell>
      </Table.Row>
    ) : (
      tableData.map((item: any, rowIndex) => (
        <Table.Row key={rowIndex}>
          <Table.Cell>{rowIndex + 1}</Table.Cell>
          {Object.entries(item).map(([key, value]:any, colIndex) => (
            <Table.Cell key={`${rowIndex}-${colIndex}`}>{value}</Table.Cell>
          ))}
        </Table.Row>
      ))
    )}
  </Table.Body>
</Table>

          </div>
        </div>
      </div>
    </>
  );
};

export default observer(NFAI_Cutliststatusreport);
